module.exports = __webpack_public_path__ + "img/logo-white.44a41ed1.png";